/**
 * 项目页面的类型
 */
export enum PROJECT_CATEGORY {
    /**
     * 个人
     */
    PERSONAL = 1,
    /**
     * 机构管理
     */
    INSITITUTION = 2,
    /**
     * 业务类项目
     */
    PROJECT = 3,
    /**
     * 体系建设类项目，制度、标准、
     */
    SYSTEM_CONSTRUCTION = 5,
    /**
     * 品牌建设类项目，ISO、高新技术、
     */
    BRAND_CONSTRUCTION = 6,

    /**
     * 库项目
     */
    LIBRARY = 11,
}

export const ProjectCategoryList = [
    { type: PROJECT_CATEGORY.PERSONAL, name: "个人" },
    { type: PROJECT_CATEGORY.INSITITUTION, name: "机构" },
    { type: PROJECT_CATEGORY.PROJECT, name: "业务" },
    { type: PROJECT_CATEGORY.SYSTEM_CONSTRUCTION, name: "体系" },
    { type: PROJECT_CATEGORY.LIBRARY, name: "库" },
]